export default __webpack_public_path__ + "static/media/LOGO CABANG DINAS-11.39e5b42a.png";